import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./app/AppShell";
import { InvalidationProvider } from "./app/invalidation";
import { LoginPage } from "./app/LoginPage";
import { RequireAuth } from "./app/RequireAuth";
import { SessionProvider } from "./app/session";
import { CreatorReportsWorkspace } from "./features/creator/CreatorReportsWorkspace";
import { FeedbackWorkspace } from "./features/feedback/FeedbackWorkspace";
import { FinanceWorkspace } from "./features/finance/FinanceWorkspace";
import { OperationsWorkspace } from "./features/operations/OperationsWorkspace";
import { PlanningWorkspace } from "./features/planning/PlanningWorkspace";
import { ProcurementWorkspace } from "./features/procurement/ProcurementWorkspace";
import { SystemWorkspace } from "./features/system/SystemWorkspace";

export default function App() {
  return (
    <SessionProvider>
      <InvalidationProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<RequireAuth />}>
            <Route element={<AppShell />}>
              <Route index element={<Navigate to="/planning" replace />} />
              <Route path="/planning" element={<PlanningWorkspace />} />
              <Route path="/procurement" element={<ProcurementWorkspace />} />
              <Route path="/operations" element={<OperationsWorkspace />} />
              <Route path="/finance" element={<FinanceWorkspace />} />
              <Route path="/feedback" element={<FeedbackWorkspace />} />
              <Route path="/system" element={<SystemWorkspace />} />
              <Route path="/creator/reports" element={<CreatorReportsWorkspace />} />
            </Route>
          </Route>
        </Routes>
      </InvalidationProvider>
    </SessionProvider>
  );
}
